import React from 'react';
import PropTypes from 'prop-types';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export const WeHaveGotIt = (props) => {
  const { content, setShowDisputeForm } = props;
  window.scrollTo(0, 0);
  return (
    <ApplicationFormShell>
      <div className="col-xs-8 text-center">
        <img
          alt="confirmation sent"
          src="../../../../images/bow/confirmation-sent.svg"
        />
        <PageHeading>{content.weHaveGotItHeader}</PageHeading>
        <p>
          <strong>{content.weHaveGotItDescriptionText1} </strong>
        </p>
        <p>
          <strong>{content.weHaveGotItDescriptionText2}</strong>
        </p>
        <p>
          <strong>{content.jointAccountUpdatesText}</strong>
        </p>
        <NavigationButton.Primary
          data-test-id="ok-got-it"
          labelText={content.okGotItButtonLabel}
          onClick={() => {
            setShowDisputeForm(false);
            AnalyticsUtil.analyticAction(
              config.analytics.analytics_experience_activity,
              config.analytics.analytics_event_method_interacted,
              config.analytics.analytics_action_dispute_we_have_got_it,
              config.analytics.analytics_action_button_click
            );
          }}
        />
      </div>
    </ApplicationFormShell>
  );
};

WeHaveGotIt.propTypes = {
  content: PropTypes.object,
  setShowDisputeForm: PropTypes.func,
};
